// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-lens-image-type-switcher[data-v-0296180a]{appearance:none;background-color:transparent;border-style:none;outline:none;padding:0}.contact-lens-image-type-switcher[data-v-0296180a]:hover{cursor:pointer}.icon[data-v-0296180a]{height:4rem;width:auto}", ""]);
// Exports
module.exports = exports;
